import { render, staticRenderFns } from "./DraftPaymentsOnBulk.vue?vue&type=template&id=98e0f6c2"
import script from "./DraftPaymentsOnBulk.vue?vue&type=script&lang=js"
export * from "./DraftPaymentsOnBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports